var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticClass:"full-height full-width"},[_c('center',[_c('v-progress-circular',{staticClass:"verticle-center horizontaly-center",attrs:{"indeterminate":"","width":"2"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }